import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "semantic-ui-less/semantic.less";
import { AppProviders } from "./context";
import App from "./App";
import ScrollToTop from "./ScrollToTop";
import * as serviceWorker from "./serviceWorker";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <AppProviders>
    <ScrollToTop />
    <App />
  </AppProviders>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
